import {
  CheckboxVisibility,
  CommandBarButton,
  DetailsList,
  Dropdown,
  IColumn,
  IContextualMenuItem,
  IDetailsRowProps,
  IIconProps,
  PrimaryButton,
  SearchBox,
  Stack,
} from '@fluentui/react';
import * as React from 'react';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import Paging from '../../../control/paging';
import ModaProduct from './modal/modalProduct';
import ModaFilterProduct from './modal/filter/modalFilterProduct';
import ModalImportProduct from './modal/modalImportProduct';
import '../../../css/components/products.scss';
import * as Api from '../../../api/src';
import ButtonMenuContext from '../../../control/ButtonMenuContext';
import { DialogContext } from '../../../context/dialog.context';
import { NoDataFound } from '../../../control/noDataFound';
import { commonfn } from '../../../common/commonfn';
import { _renderRow } from '../../../control/function/detailList';
import { StatusItem } from '../../../control/statusItem';
import { Loading } from '../../../control/loading';
import { saveAs } from 'file-saver';
import { TooltipHost, ITooltipHostStyles } from '@fluentui/react/lib/Tooltip';
import { useId } from '@fluentui/react-hooks';
import { IconButton } from '@fluentui/react/lib/Button';

const ProductsApi = new Api.ProductsApi();
const ProductTypesApi = new Api.ProductTypesApi();
const defaultFilter = {
  Page: 1,
  ProductTypeId: 0,
  BrandId: 0,
  CategoryId: 0,
  VendorId: 0,
  Year: 0,
  PageSize: 20,
} as Api.GetPagedProductsQuery;
let FilterQueryCache = defaultFilter as Api.GetPagedProductsQuery | null;

const calloutProps = { gapSpace: 0 };
const hostStyles: Partial<ITooltipHostStyles> = { root: { display: 'inline-block' } };

const Product = () => {
  const { setMsgConfirmDialog, setCallBackConfirmDialog } = React.useContext(DialogContext);
  const { t } = useTranslation();
  const tooltipId = useId('tooltip');
  const InfoIcon: IIconProps = { iconName: 'Info' };
  const _columns = [
    {
      key: 'action',
      name: '',
      isResizable: true,
      minWidth: 20,
      maxWidth: 20,
      onRender: (item: Api.ProductModel) => {
        let menuItems: IContextualMenuItem[] = [
          {
            key: 'Edit',
            text: t('Edit'),
            onClick: (ev) => {
              SetItemSelected(item);
              SetIsOpenModal(true);
              console.log(item.Id);
            },
          },
          {
            key: 'Delete',
            text: t('Delete'),
            onClick: (ev) => {
              setMsgConfirmDialog(t('AreYouSureYouWantToDeleteThisData'));
              setCallBackConfirmDialog({ action: deleteItem, param: item.Id });
              console.log(item.Id);
            },
          },
        ];
        return <ButtonMenuContext ClassName={'menuContextDefault'} MenuItems={menuItems} IconName={'MoreVertical'} />;
      },
    },
    {
      key: 'Model',
      name: t('Model'),
      className: 'flex-center',
      isResizable: true,
      minWidth: 300,
      onRender: (item: Api.ProductModel) => {
        return <Stack horizontal>
          <div className='flex-center'>{`[${item.Code}] ` + item.Name}</div>
          {!item.HaveSpecification && <TooltipHost
            content="No specification"
            id={tooltipId}
            calloutProps={calloutProps}
            styles={hostStyles}
          >
            <IconButton styles={{
              root: {
                color: 'red',
              },
            }} iconProps={InfoIcon} aria-label="info" disabled={false} checked={false} />
          </TooltipHost>
          }
        </Stack>
        
      },
    },
    {
      key: 'Category',
      name: t('Category'),
      fieldName: 'CategoryName',
      className: 'flex-center',
      maxWidth: 300,
      minWidth: 200,
    },
    {
      key: 'Brand',
      name: t('Brand'),
      fieldName: 'BrandName',
      className: 'flex-center',
      maxWidth: 200,
      minWidth: 200,
    },
    { key: 'Year', name: t('Year'), fieldName: 'Year', className: 'flex-center', maxWidth: 100, minWidth: 100 },
    {
      key: 'Status',
      name: t('Status'),
      className: 'flex-center',
      maxWidth: 100,
      minWidth: 100,
      onRender: (item: Api.ProductModel) => {
        return (
          <StatusItem
            Status={item.States || Api.StatesEnum.Inactive}
            Name={t(commonfn.getActiveName(item.States))}
          ></StatusItem>
        );
      },
    },
  ] as IColumn[];
  const addIcon: IIconProps = { iconName: 'Filter' };
  const clearIcon: IIconProps = { iconName: 'ClearFilter' };
  const mailIcon: IIconProps = { iconName: 'Settings' };
  const [isOpenModal, SetIsOpenModal] = React.useState(false);
  const [isOpenModalImport, SetIsOpenModalImport] = React.useState(false);
  const [isOpenModalFilter, SetIsOpenModalFilter] = React.useState(false);
  const [itemSelected, SetItemSelected] = React.useState<Api.ProductModel | undefined>(undefined);
  const [FilterQuery, setFilterQuery] = React.useState<Api.GetPagedProductsQuery>(defaultFilter);
  const [listProduct, setListProduct] = React.useState<Api.ProductModelIEnumerableApiResponse | null>(null);
  const [isChangeFilter, SetIsChangeFilter] = React.useState(false);
  const [listYears, setListYears] = React.useState<any[]>([]);
  const [listProductType, setListProductType] = React.useState<any[]>([]);
  const [isShowLoading, SetIsShowLoading] = React.useState(true);
  const [columns, setColumns] = React.useState<any[]>(_columns);

  const getList = async () => {
    SetIsShowLoading(true);
    let data = (await ProductsApi.apiProductsPagedPost(FilterQuery)).data;
    setListProduct(data);
    setTimeout(() => {
      SetIsShowLoading(false);
    }, 500);
  };
  const getAllProductTypes = async () => {
    if (listProductType.length > 0) return;
    let data = (
      await ProductTypesApi.apiProductTypesPagedPost({
        PageNumber: 1,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
      })
    ).data;
    let productTypes: any[] = [{ key: 0, text: t('AllProductTypes') }];
    data.Data?.forEach((element) => {
      productTypes.push({ key: element.Id, text: element.Name });
    });
    setListProductType(productTypes);
  };
  const deleteItem = async (id: number) => {
    await ProductsApi.apiProductsIdSetStatesPatch(id, Api.StatesEnum.Delete);
    setFilterQuery({ ...FilterQueryCache, Page: 1 });
  };
  React.useEffect(() => {
    getYears();
    getAllProductTypes();
  }, []);
  let timeOutGetList: any = null;
  React.useEffect(() => {
    if (FilterQueryCache?.Search !== FilterQuery.Search) {
      if (timeOutGetList) {
        clearTimeout(timeOutGetList);
        timeOutGetList = null;
      }
      timeOutGetList = setTimeout(() => {
        getList();
        timeOutGetList = null;
      }, 350);
      FilterQueryCache = FilterQuery;
      return () => window.clearTimeout(timeOutGetList);
    } else {
      getList();
      FilterQueryCache = FilterQuery;
    }
  }, [FilterQuery]);
  const getYears = async () => {
    if (listYears.length > 0) return;
    let years: any[] = [];
    commonfn.getListYears().forEach((element) => {
      years.push({ key: element, text: element.toString() });
    });
    setListYears(years);
  };
  React.useEffect(() => {
    if (
      FilterQuery.BrandId !== defaultFilter.BrandId ||
      FilterQuery.CategoryId !== defaultFilter.CategoryId ||
      FilterQuery.VendorId !== defaultFilter.VendorId ||
      FilterQuery.Year !== defaultFilter.Year
    ) {
      SetIsChangeFilter(true);
    } else {
      SetIsChangeFilter(false);
    }
  }, [FilterQuery.BrandId, FilterQuery.CategoryId, FilterQuery.VendorId, FilterQuery.Year]);

  const getTotalPage = (totals: number, pageSize: number) => {
    return Math.ceil(totals / pageSize);
  }

  const _onColumnClick = (event: MouseEvent<HTMLElement> | undefined, column: IColumn | undefined) => {
    if (column?.name) {
      SetIsShowLoading(true);
      const newColumns: IColumn[] = columns.slice();
      const currColumn: IColumn = newColumns.filter((currCol) => column?.key === currCol.key)[0];
      newColumns.forEach((newCol: IColumn) => {
        if (newCol === currColumn) {
          currColumn.isSortedDescending = !currColumn.isSortedDescending;
          currColumn.isSorted = true;
        } else {
          newCol.isSorted = false;
          newCol.isSortedDescending = true;
        }
      });

      setFilterQuery({ ...FilterQuery, SortField: column?.key, IsDescending: currColumn.isSortedDescending });
      setColumns(newColumns);
    }
  };
  return (
    <>
      <div className="page-content ">
        <Loading isShow={isShowLoading}></Loading>
        <div className="ms-Grid  form-list" dir="ltr">
          <div className="ms-Grid-row display-flex">
            <div className="ms-Grid-col padding-left-0 ms-md1" style={{ width: 250 }}>
              <Dropdown
                options={listProductType}
                selectedKey={FilterQuery.ProductTypeId}
                onChange={(e, newValue) => {
                  setFilterQuery({ ...FilterQuery, ProductTypeId: (newValue?.key as number) || 0, Page: 1 });
                }}
              ></Dropdown>
            </div>
            <div className="ms-Grid-col padding-left-0 margin-right-auto ms-md2" style={{ minWidth: 250 }}>
              <SearchBox
                placeholder={t('Search')}
                onChange={(e, newValue) => {
                  setFilterQuery({ ...FilterQuery, Search: newValue || '', Page: 1 });
                }}
              />
            </div>
            <div className="ms-Grid-col ms-sm6">
              <Stack horizontal className="header-action">
                {(isChangeFilter && (
                  <CommandBarButton
                    iconProps={clearIcon}
                    text={t('ClearFilter')}
                    className={'margin-left-auto'}
                    onClick={() => {
                      debugger;
                      setFilterQuery({
                        ...defaultFilter,
                        PageSize: FilterQuery.PageSize,
                        ProductTypeId: FilterQuery.ProductTypeId,
                      });
                    }}
                  />
                )) || (
                  <CommandBarButton
                    iconProps={addIcon}
                    text={t('Filter')}
                    className={'margin-left-auto'}
                    onClick={() => {
                      SetIsOpenModalFilter(true);
                    }}
                  />
                )}
                &nbsp;
                <CommandBarButton
                  iconProps={mailIcon}
                  text={t('Tool')}
                  menuProps={{
                    items: [
                      {
                        key: 'Import',
                        text: t('Import'),
                        onClick: () => {
                          SetIsOpenModalImport(true);
                        },
                      },
                      {
                        key: 'Export',
                        text: t('Export'),
                        onClick: () => {
                          ProductsApi.apiProductsExportProductPost(FilterQuery, {
                            responseType: 'blob',
                          }).then((res) => {
                            saveAs((res as any).data as Blob, `Products.xlsx`);
                          });
                        },
                      },
                    ],
                  }}
                />
                &nbsp; &nbsp;
                <PrimaryButton
                  text={t('New')}
                  onClick={() => {
                    SetIsOpenModal(true);
                    SetItemSelected(undefined);
                  }}
                />
              </Stack>
            </div>
          </div>
        </div>
        <div className="ms-Grid-row">
          {(listProduct?.Data?.length || 0) > 0 && (
            <div className="ms-Grid-col ms-sm12">
              <DetailsList
                items={listProduct?.Data || []}
                columns={columns}
                checkboxVisibility={CheckboxVisibility.hidden}
                onColumnHeaderClick={_onColumnClick}
                onRenderRow={(props) => {
                  return _renderRow(props || ({} as IDetailsRowProps), () => {
                    SetItemSelected(props?.item);
                    SetIsOpenModal(true);
                  });
                }}
              />
            </div>
          )}
          <NoDataFound isShow={listProduct?.Data?.length === 0}></NoDataFound>
          <Paging
            CurrentPage={FilterQuery.Page}
            TotalPage={ getTotalPage(listProduct?.Totals || 0, FilterQuery.PageSize || 0)}
            onChangePage={(page, pageSize) => {
              setFilterQuery({ ...FilterQuery, Page: page, PageSize: pageSize });
            }}
          ></Paging>
        </div>
      </div>
      {isOpenModal && (
        <ModaProduct
          IsOpen={isOpenModal}
          ProductType={FilterQuery.ProductTypeId}
          Item={itemSelected}
          onCloseModal={() => {
            SetIsOpenModal(false);
          }}
          onSaveClick={() => {
            setFilterQuery({ ...FilterQuery, Page: 1 });
          }}
        ></ModaProduct>
      )}
      <ModalImportProduct
        IsOpen={isOpenModalImport}
        onCloseModal={() => {
          SetIsOpenModalImport(false);
        }}
      ></ModalImportProduct>
      {isOpenModalFilter && (
        <ModaFilterProduct
          IsOpen={isOpenModalFilter}
          FilterItem={FilterQuery}
          onCloseModal={() => {
            SetIsOpenModalFilter(false);
          }}
          onOkClick={(filterItem) => {
            setFilterQuery({ ...filterItem, Page: 1 });
            SetIsOpenModalFilter(false);
          }}
        ></ModaFilterProduct>
      )}
    </>
  );
};
export default Product;
